import Loader from '@ui/context/session/components/Common/Loader';
import BaseOverlay from './BaseOverlay';

const SessionLoading = () => {
  return (
    <BaseOverlay>
      <Loader size="large" text="Gathering Session Details..." />
    </BaseOverlay>
  );
};

export default SessionLoading;
